import { useTheme } from "@emotion/react";
import { Button, Container, Grid, Paper } from "@mui/material";
import { Fragment } from "react";
import logo from "../assets/images/Acquaount-logo.png";
import { useTranslation } from "react-i18next";
import { resetPasswordRequest } from "shared-components/src/components/resetPassword/store/resetPassword.actions";
import ResetPasswordComponent from "shared-components/src/components/resetPassword/resetPassword.component";

const ResetPasswordPage = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Fragment>
      <div
        style={{
          background: theme.palette.primary.main,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={10} md={5}>
              <Paper elevation={3} style={{ padding: "20px" }}>
                <ResetPasswordComponent
                  logo={logo}
                  onResetPassword={resetPasswordRequest}
                />
                <Grid container spacing={2} style={{ marginTop: "5px" }}>
                  <Grid item xs={12}>
                    <Button
                      variant="outlined"
                      color="primary"
                      fullWidth
                      href="/login"
                    >
                      {t("login")}
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </div>
    </Fragment>
  );
};

export default ResetPasswordPage;
